import React from 'react';
import { Link } from 'react-router-dom';

// Adjust these imports to match your project structure
import LogoSVG from '../assets/BantrBoxLogo.svg';
import Footer from '../components/Footer';

const Terms = () => {
  return (
    <div className="bg-white text-gray-800 min-h-screen flex flex-col">
      {/* Header Bar */}
      <header className="bg-[#333333] shadow-sm text-white">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img 
              src={LogoSVG} 
              alt="BantrBox Logo" 
              className="h-12 w-auto"
            />
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 py-10 px-4">
        <div className="max-w-4xl mx-auto space-y-6">
          <h1 className="text-4xl font-bold mb-4 leading-tight">Terms &amp; Conditions</h1>
          <p className="text-sm text-gray-500">
            Last Updated: 2024-12-16
          </p>

          <p className="leading-relaxed">
            Welcome to BantrBox. By accessing or using our platform (the “Service”), 
            you agree to be bound by these terms and conditions (the “Terms”). 
            Please read them carefully. If you do not agree with these Terms, 
            you should discontinue use of the Service immediately.
          </p>

          <h2 className="text-2xl font-semibold mt-8">1. Acceptance of Terms</h2>
          <p className="leading-relaxed">
            By creating an account, participating in challenges, or otherwise using 
            the Service, you acknowledge that you have read, understood, and agree 
            to these Terms. If you do not agree, you do not have the right to access 
            or use our Service.
          </p>

          <h2 className="text-2xl font-semibold mt-8">2. Changes to These Terms</h2>
          <p className="leading-relaxed">
            We reserve the right to modify these Terms at any time. When we do so, 
            we will post the revised Terms on this page and update the “Last Updated” 
            date. Your continued use of the Service after any such changes indicates 
            your acceptance of the new Terms.
          </p>

          <h2 className="text-2xl font-semibold mt-8">3. Eligibility &amp; Accounts</h2>
          <p className="leading-relaxed">
            You must be at least 18 years old (or the age of majority in your jurisdiction) 
            to create an account. You agree to provide accurate, current, and complete 
            information about yourself when creating or updating your account. You are 
            responsible for maintaining the confidentiality of your login credentials.
          </p>

          <h2 className="text-2xl font-semibold mt-8">4. Prohibited Activities</h2>
          <p className="leading-relaxed">
            You agree not to use the Service for any unlawful or harmful purpose. This 
            includes, but is not limited to, posting inappropriate content, harassing 
            other users, attempting to gain unauthorized access to the platform, or 
            engaging in fraudulent activities.
          </p>

          <h2 className="text-2xl font-semibold mt-8">5. Intellectual Property</h2>
          <p className="leading-relaxed">
            All content, features, and functionality of the Service (including text, 
            graphics, logos, and software) are owned by BantrBox or its licensors and are 
            protected by intellectual property laws. You may not reproduce, distribute, 
            or create derivative works of such materials without our explicit permission.
          </p>

          <h2 className="text-2xl font-semibold mt-8">6. User-Generated Content</h2>
          <p className="leading-relaxed">
            You retain ownership of the content you submit to the Service, such as comments, 
            posts, or challenge ideas. By posting or submitting content, you grant BantrBox 
            a non-exclusive, royalty-free, worldwide license to use, display, reproduce, and 
            distribute your content in connection with operating and providing the Service.
          </p>

          <h2 className="text-2xl font-semibold mt-8">7. Disclaimer &amp; Limitation of Liability</h2>
          <p className="leading-relaxed">
            The Service is provided “as is” and “as available.” To the fullest extent 
            permitted by law, BantrBox disclaims all warranties, express or implied. 
            BantrBox shall not be liable for any indirect, incidental, special, or 
            consequential damages arising out of or related to your use of the Service.
          </p>

          <h2 className="text-2xl font-semibold mt-8">8. Indemnification</h2>
          <p className="leading-relaxed">
            You agree to indemnify, defend, and hold harmless BantrBox, its affiliates, 
            and their respective officers, directors, employees, and agents from any 
            claims, liabilities, damages, or expenses arising out of your use of the 
            Service or violation of these Terms.
          </p>

          <h2 className="text-2xl font-semibold mt-8">10. Contact Us</h2>
          <p className="leading-relaxed">
            If you have any questions about these Terms, please contact us at 
            <a href="mailto:support@bantrbox.com" className="text-blue-600 underline"> support@bantrbox.com</a>.
          </p>
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Terms;
